// SEO / GEO city landing pages
export const CITIES = [
  { slug: "bratislava", name: "Bratislava", region: "Bratislavský kraj", district: "Bratislava",
    intro: "Zatepľujeme rodinné a bytové domy v celej Bratislave a okolí — od Petržalky po Nové Mesto." },
  { slug: "kosice", name: "Košice", region: "Košický kraj", district: "Košice",
    intro: "Kvalitné zateplenie fasád domov a bytoviek v Košiciach a okrese Košice-okolie." },
  { slug: "zilina", name: "Žilina", region: "Žilinský kraj", district: "Žilina",
    intro: "Zateplenie rodinných domov a bytových domov v Žiline s overeným partnerom v regióne." },
  { slug: "nitra", name: "Nitra", region: "Nitriansky kraj", district: "Nitra",
    intro: "Profesionálne zatepľovacie práce v Nitre — materiál, práca, lešenie aj doprava na jednom mieste." },
  { slug: "presov", name: "Prešov", region: "Prešovský kraj", district: "Prešov",
    intro: "Zateplenie domov v Prešove a okolí. Prepočet ceny online do 60 sekúnd." },
  { slug: "banska-bystrica", name: "Banská Bystrica", region: "Banskobystrický kraj", district: "Banská Bystrica",
    intro: "Zatepľujeme fasády rodinných a bytových domov v Banskej Bystrici a celom kraji." },
  { slug: "trnava", name: "Trnava", region: "Trnavský kraj", district: "Trnava",
    intro: "Zateplenie domov v Trnave — od projektu po hotovú fasádu s overeným realizátorom." },
  { slug: "trencin", name: "Trenčín", region: "Trenčiansky kraj", district: "Trenčín",
    intro: "Kompletné zatepľovacie práce v Trenčíne a okolí. Orientačná cena okamžite." },
  { slug: "martin", name: "Martin", region: "Žilinský kraj", district: "Martin",
    intro: "Zateplenie rodinných domov a bytoviek v Martine s dôrazom na kvalitu a termín." },
  { slug: "poprad", name: "Poprad", region: "Prešovský kraj", district: "Poprad",
    intro: "Zatepľujeme domy pod Tatrami — Poprad a okolie. Odolné systémy pre horské podnebie." },
  { slug: "nove-zamky", name: "Nové Zámky", region: "Nitriansky kraj", district: "Nové Zámky",
    intro: "Zateplenie fasád rodinných a bytových domov v Nových Zámkoch a okolí." },
  { slug: "michalovce", name: "Michalovce", region: "Košický kraj", district: "Michalovce",
    intro: "Zatepľovacie práce v Michalovciach — materiál, montáž, lešenie aj doprava." },
];

export const cityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
